import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

import { Helmet } from 'react-helmet-async';


function GroundPowerSupply() {
    const [active, setActive] = useState("Safe Area");
    const navigate = useNavigate();
    return (
        <>
        <Helmet>
    <title>
        In-Ground Power Supply Units UAE | Outdoor Power Solutions | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar offers innovative in-ground power supply units (IGU) in the UAE for parks, stadiums, marketplaces, public spaces and urban infrastructure, providing discreet and reliable access to power, water, compressed air, video, audio and data."
    />

    <meta
        name="keywords"
        content="in-ground power supply units UAE, IGU UAE, in ground power units UAE, outdoor power supply UAE, underground power supply UAE, public space power solutions UAE, IP66 power supply units UAE, BS EN 124 UAE, urban power supply units UAE, outdoor electrical units UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/GroundPowerSupply"
    />

    <meta
        property="og:title"
        content="In-Ground Power Supply Units UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Discreet and durable in-ground power supply units for public spaces and outdoor infrastructure, with IP66-rated electrical components."
    />

    <meta
        property="og:url"
        content="https://saig.me/GroundPowerSupply"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">In Ground Power Supply Units (IGU)</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Discreet and durable power supply access below ground.
                    </p>
                </div>
            </div>
            {/* <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                className="mt-[91px] overflow-hidden relative"
            >
                <motion.img
                    initial={{ scale: 1.2 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 1.2, ease: 'easeOut' }}
                    src="/assets/service/bg3.png"
                    className="w-full lg:h-auto h-[300px] object-cover"
                    alt="	Trusted cable management and termination solutions provider in the UAE"
                />
                <div className="absolute lg:top-[125px] top-[20px] max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] left-1/2 -translate-x-1/2">
                    <motion.h6
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.7 }}
                        className="font-[500] font-kanit lg:text-[70px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]"
                    >
                        In Ground Power Supply Units (IGU)
                    </motion.h6>
                    <motion.p
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.5, duration: 0.7 }}
                        className="max-w-[582px] w-full font-[300] font-inter text-[20px] leading-[30px] text-[#FFFFFF]"
                    >
                        Discreet and durable power supply access below ground.


                    </motion.p>
                </div>
                <motion.h1
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    className="absolute font-[600] font-kanit lg:text-[180px] text-[60px] lg:leading-[180px] leading-[70px] text-[#FFFFFF4F] right-[0px] lg:bottom-[86px] bottom-[40px]"
                >
                    Supply Units
                </motion.h1>
            </motion.div> */}

            <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[80px]'>

                <div className='detail-div-left'>

                    <div className='main-img'>

                        <img src='/assets/s.jpg' />
                    </div>


                </div>

                <div className='detail-div-right'>
                    <h3>In Ground Power Supply Units (IGU) </h3>

                    {/* <p>I've designed and animated a product detail page for a luxury e-commerce platform, focusing on delivering a seamless and premium user experience.</p> */}



                    <h4></h4>

                    <br />
                    <div className='lines'></div>
                    <br />
                    <div className='detail-des'>
                        <p>Description :</p>

                        <h5>In Ground Power Supply Units (IGU) are innovative, space-saving solutions designed to provide safe and discreet electrical access in outdoor and public spaces. Installed flush with the ground, these units offer protection against weather, dust, and tampering, making them ideal for parks, stadiums, event venues, marketplaces, and urban infrastructure. IGUs are built to handle harsh environmental conditions while ensuring continuous and reliable power supply. Their retractable or covered designs ensure safety, convenience, and aesthetics without compromising functionality.

                        </h5>
                        <br />
                        <div className='detail-div-p '>
                            <h3>Heat Shrink Tubing</h3>

                            <p>
                                YK Electric efficient in ground power supply units provide electricity for public spaces such as urban areas, historic sites, market places, town squares and parks without the hassle of temporary installations and messy wire network, thus making it an ideal choice for the architects, planners and end users.
                                In ground power supply units are designed to provide power, water, compressed air, video, audio and data.
                                The applicable British standard for IGU is BS EN 124:2015, with IP66 rating.
                                Advantages of YK Electric range of systems
                                <br /><br />•	Availability of electrical power in seconds
                                <br />•	Eliminates the requirement of messy cable networks
                                <br />•	Permanent in nature
                                <br />•	Ease of use
                                <br />•	Easy to open and close after use
                                <br />•	Dual locking arrangements to prevent accidents
                                <br />•	In built gas springs for automatic opening
                                <br />•	Protection against theft and intrusions
                                <br />•	Camouflage with the surroundings
                                <br />•	Maintenance free
                                <br />•	IP Rated electrical components
                                <br />•	100% units can be customised to meet local requirements
                                <br />•	No MOQ
                            </p>
                            <br /><br />
                        </div>
                    </div>
                </div>
            </div>


            {/* <section style={{ background: `radial-gradient(104.59% 215.16% at 95% 10%, rgba(228, 74, 26, 0.16) 0%, rgba(228, 74, 26, 0) 29%), radial-gradient(104.59% 215.16% at 5% 90%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)` }} className='lg:px-[100px] px-[20px]'>
                      <h6 className="font-[500] font-kanit lg:text-[42px] text-[30px] lg:leading-[50px] leading-[38px] text-[#000000] lg:pb-[80px] pb-[40px]">Product Recommendation</h6>
                      <div className="grid lg:grid-cols-3 grid-cols-2 lg:gap-[36px] gap-[20px] lg:pb-[142px] pb-[80px]">
                          <div>
                              <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                                  <img src="/assets/product/img1.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                                  <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                      View Details
                                  </button>
                              </div>
                              <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                                  junction box & enclosures
                              </h6>
                              <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                                  Polymer & Sheet Metal
                              </p>
                          </div>
                          <div>
                              <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                                  <img src="/assets/product/img2.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                                  <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                      View Details
                                  </button>
                              </div>
                              <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                                  re-enterable gel 7 fillers
                              </h6>
                              <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                                  Re-usable & Cast
                              </p>
                          </div>
                          <div>
                              <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                                  <img src="/assets/product/img3.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                                  <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                      View Details
                                  </button>
                              </div>
                              <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                                  Cables
                              </h6>
                              <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                                  Power & Instrumentation
                              </p>
                          </div>
                      </div>
                  </section> */}
        </>
    )
}

export default GroundPowerSupply